import { useTLang } from 'intl/intl';

type Variant = 'list' | 'detail';

export function useSOListErrorLang(variant: Variant = 'list') {
  const isDetail = variant === 'detail';

  return {
    errorTitle: useTLang({
      id: isDetail
        ? 'scheduleOrder.detail.errorTitle'
        : 'scheduleOrder.errorTitle',
    }),
    errorDescription: useTLang({
      id: isDetail
        ? 'scheduleOrder.detail.errorDescription'
        : 'scheduleOrder.errorDescription',
    }),
    errorRetry: useTLang({ id: 'scheduleOrder.errorRetry' }),
  };
}
